import { workflowRepository } from "motw_core/Repositories/WorkflowRepository";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { UpdateDataForNodeCompletionAsync } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ChildNodeName/CompleteNode/Helpers/ExecuteNodeCompletion";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";

export async function CompleteAllTodayNodesAsync() {
    const incompleteNodes = await WithAnimatedProgressBarAsync(() =>
        workflowRepository.GetIncompleteNodes(ClientDataProvider)
    );

    for (const node of incompleteNodes) {
        await UpdateDataForNodeCompletionAsync(node);
    }

    Data.Load.AllAsync();
}
